import xw from 'xwind';
import styled from '@emotion/styled';

export const CardWrapper = styled.div(
  xw`
    flex flex-col mb-10 
    md[mb-20 flex-row] last:mb-0
  `,
);
